export default __webpack_public_path__ + "static/media/weddings-and-engagements.b3e658da.jpg";